import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { useDispatch } from "react-redux"
import ModalComponent from "../Modal/Modal"
import { showSnackBar } from "../Snackbar/Snackbar"
import EmailSettingsFields from "./EmailSettingsFields"
import { orderGroupKeys } from "./emailGroups"
import { getOwnEmailSettings, saveOwnEmailSettings } from "../../features/emailSettings/emailSettings"

const NOTHING_MUTED = { muteAll: false, mutedGroups: [] }

const EmailSettingsDialog = ({ onClose }) => {
  const dispatch = useDispatch()
  const [value, setValue] = useState(NOTHING_MUTED)
  const [loading, setLoading] = useState(true)
  const [loadFailed, setLoadFailed] = useState(false)
  const [saving, setSaving] = useState(false)
  const [closeSignal, setCloseSignal] = useState(false)

  useEffect(() => {
    let active = true
    dispatch(getOwnEmailSettings()).then((result) => {
      if (!active) return
      if (result.error) {
        setLoadFailed(true)
      } else {
        setValue({
          muteAll: result.payload?.muteAll === true,
          mutedGroups: orderGroupKeys(result.payload?.mutedGroups),
        })
      }
      setLoading(false)
    })
    return () => {
      active = false
    }
  }, [dispatch])

  const handleSave = async () => {
    setSaving(true)
    const result = await dispatch(saveOwnEmailSettings(value))
    setSaving(false)
    if (result.error) {
      showSnackBar('error', result.payload || 'Could not save your email settings')
      return
    }
    showSnackBar('success', 'Email settings saved')
    setCloseSignal((prev) => !prev)
  }

  return (
    <ModalComponent
      title="Email notifications"
      customOpenModal={true}
      disableBtn={false}
      onClose={onClose}
      modalButtonTitle="Save"
      functionButton={handleSave}
      disableCloseFunctionButton={true}
      triggerCloseModal={closeSignal}
      disabled={loading || saving || loadFailed}
      modalWidth="min-w-[520px]"
    >
      {loadFailed && (
        <p className="text-sm text-text-secondary">Could not load your email settings. Close and try again.</p>
      )}
      {!loadFailed && loading && <p className="text-sm text-text-secondary">Loading…</p>}
      {!loadFailed && !loading && <EmailSettingsFields value={value} onChange={setValue} disabled={saving} />}
    </ModalComponent>
  )
}

EmailSettingsDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
}

export default EmailSettingsDialog
